module.exports = __webpack_public_path__ + "img/phone-mockup.a7c9f983.png";